<template>
	<div 
	class="pdf-view-header flex items-center justify-end py-4 px-8"
	v-if="pdf">

		<div v-if="title" class="absolute z-back inset-0 overflow-hidden uppercase text-xs font-main-bold flex justify-center items-center py-4 px-64">
			<p>{{title}}</p>
		</div>

		<div>
			<a
			class="inline-block border rounded-md mr-4 p-2"
			:href="pdf.url"
			target="_blank"
			download>
				Télécharger
			</a>

			<!-- Close button -->
			<div
			class="inline-block cursor-pointer"
			@click.prevent="close">
				<img
				class="w-4"
				src="@/assets/images/close-icon.svg">
				</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PDFViewHeader',
		props: {
			title: {
				type: String,
				required: false,
				default: null
			},
			pdf: {
				type: Object,
				required: false,
				default: null
			}
		},
		methods: {
			previousPage() {
				this.$emit('previous')
			},
			nextPage() {
				this.$emit('next')
			},
			close() {
				this.$emit('close')
			},
		},
	}
</script>

<style lang="scss" scoped></style>
